import {render, h} from "preact";
import { Like } from "./like";
import css from "./app.css";
let style = document.createElement("style");
style.innerHTML = css;
document.head.appendChild(style);
render(<Like />, document.getElementById("like-container"));


